/**
 * 商户卡片域 API 错误码表（卡域唯一数据源）。
 *
 * 背景：client.ts 失败分支透传后端 Result 信封业务码（code 字符串，如
 * "CARD_422" / "CARD_REVEAL_422" / "42901" / "CARD_404"），页面 toast 需要
 * 按 code 给出可行动的中文提示；未收录 code 回退后端 message。
 *
 * B3 起本模块只维护码表，不再导出映射函数：统一入口为
 * `apiErrorMessages.ts` 的 `mapApiError(code, fallback, { domain: 'card' })`
 * ——卡域先查本表，再回退领域/通用表（单轨，禁止另建映射入口）。
 */

/**
 * 后端业务码 → 用户可读提示（键对齐 allinks-common ErrorCode 的 code 字符串，
 * 非 Spring 的 HTTP 状态码；成功信封 code=0 不进入本表）。
 * 键 ⊆ ErrorCode.java 码值集合由 apiErrorCodes.guard.test.ts 守护。
 */
export const CARD_API_ERROR_MESSAGES: Readonly<Record<string, string>> = {
  // ErrorCode.CARD_SENSITIVE_DATA_MISSING：pan/cvv 密文或密钥缺失、解密失败
  CARD_422: '该卡敏感数据缺失，无法出示完整卡号，请联系平台处理',
  // ErrorCode.CARD_REVEAL_FORBIDDEN：仅 ACTIVE 虚拟卡可查看完整卡号
  CARD_REVEAL_422: '仅已激活（ACTIVE）虚拟卡可查看完整卡号',
  // ErrorCode.REVEAL_RATE_LIMIT_EXCEEDED：10min ≤3 次/卡、24h ≤20 次/账号
  '42901': '操作过于频繁，请稍后再试',
  // ErrorCode.CARD_NOT_FOUND：卡片不存在或不属于本商户（租户隔离同口径）
  CARD_404: '卡片不存在或不属于本商户',
  // ErrorCode.CARD_PAN_FORBIDDEN：越权（跨商户 / 跨持卡人资金来源）
  AUTH_403: '无权执行该操作，请确认卡片归属后重试',
  // ErrorCode.VALIDATION_ERROR：充值/划拨金额、accountId 等参数校验失败（与通用表同文案）
  VAL_400: '请求参数有误，请检查填写内容后重试',
};
